import { render } from "./MdHint.vue?vue&type=template&id=3613b01f&scoped=true&ts=true"
import script from "./MdHint.vue?vue&type=script&lang=ts"
export * from "./MdHint.vue?vue&type=script&lang=ts"

import "./MdHint.vue?vue&type=style&index=0&id=3613b01f&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3613b01f"]])

export default __exports__